namespace Solovis.Site.TelemetryHelper {
    // NOTE: Can we include the types?
    // NOTE: DD.beforeSend can be used to discard errors, modify properties, etc
    // NOTE: https://docs.datadoghq.com/real_user_monitoring/guide/enrich-and-control-rum-data/?tab=event#discard-a-frontend-error
    function datadogBeforeSend(event, context) {
        // NOTE: return false to discard the event
        // return false;
    }

    export function initDatadog(options: DatadogOptions ) {

        if(options.applicationId && options.clientToken && options.rumEnv){
            const info = (Solovis as any).Info;
            const dd = (window as any).DD_RUM;

            if(dd){
                dd.init({
                    applicationId: options.applicationId,
                    clientToken: options.clientToken,
                    env: options.rumEnv,
    
                    sessionReplaySampleRate: 0,
                    sessionSampleRate: options.sessionSampleRate,
                    traceSampleRate: options.sessionSampleRate,
    
                    defaultPrivacyLevel: 'mask',
                    service: 'portfolio-analytics',
                    site: 'datadoghq.com',
                    trackLongTasks: true,
                    trackResources: true,
                    // Use local-storage for storing context, available cross tabs/reloads
                    storeContextsAcrossPages: true,
                    trackUserInteractions: false,   // do not enable
                    allowedTracingUrls: [
                        // local dev
                        /https:\/\/.*\.gateway\.devlocal\.solovis\.com/, 
                        // gateways
                        /https:\/\/.*\.([\w-]+)?gateway\.solovis\.com/, 
                    ],
                    // do not include URLs below when calculating timings, etc
                    // https://docs.datadoghq.com/real_user_monitoring/browser/monitoring_page_performance/#how-page-activity-is-calculated
                    excludedActivityUrls: [
                        // Exclude exact URLs
                        // 'https://third-party-analytics-provider.com/endpoint',
                
                        // Exclude any URL ending with /comet
                        // /\/comet$/,
                
                        // Exclude any URLs for which the function return true
                        // (url) => url === 'https://third-party-analytics-provider.com/endpoint',
                        (url:string) => {
                            const lowerUrl = url.toLowerCase();
                            const ignoreUrls = [ "pendo", "configcat" ]
                            return ignoreUrls.some( (ignoreUrl) => lowerUrl.indexOf(ignoreUrl) > -1 )
                        },
                    ],
                    beforeSend: datadogBeforeSend
                });
                
                dd.setUser({
                    id: info.userCode,
                    orgCode: info.orgRef
                });
        
                dd.setGlobalContextProperty('dataEnvironmentId', options.dataEnvironmentId);
            }            
        }        
    }    

    export type DatadogOptions = {
        applicationId: string;
        clientToken: string;
        dataEnvironmentId: number;
        rumEnv: string;
        sessionSampleRate: number;
    }    
}